import { render, staticRenderFns } from "./TextFileLoadBackupPopup.vue?vue&type=template&id=71f86419&scoped=true&"
import script from "./TextFileLoadBackupPopup.vue?vue&type=script&lang=js&"
export * from "./TextFileLoadBackupPopup.vue?vue&type=script&lang=js&"
import style0 from "./TextFileLoadBackupPopup.vue?vue&type=style&index=0&id=71f86419&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f86419",
  null
  
)

export default component.exports